import { render, staticRenderFns } from "./KnowledgeFilter.vue?vue&type=template&id=c870f768&"
import script from "./KnowledgeFilter.vue?vue&type=script&lang=js&"
export * from "./KnowledgeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports